<template>
  <div>
    <v-dialog
      :value="enableDialog"
      eager
      persistent
      width="1200"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card
        flat
      >
        <v-toolbar flat>
          <v-toolbar-title>更新履歴</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                :headers="updateHistoryHeaders"
                :items="changeHistories"
                :items-per-page="-1"
                dense
                disable-sort
                fixed-header
                hide-default-footer
                height="360"
              >
                <template v-slot:[`item.updated_at`]="{ item }">
                  {{ item.updated_at | unix_datetime_format }}
                </template>
                <template v-slot:[`item.updated_by`]="{item}">
                  <div :title="item.updated_by" class="ellipsis-text" style="width:120px !important;">{{item.updated_by}}</div>
                </template>
                <template v-slot:[`item.detail`]="{ item }">
                  <div
                    v-for="(detail, index) in item.detail"
                    :key="index"
                    class="ellipsis-text"
                    style="width: 490px !important;"
                    :title="`＜${detail.label}＞ 旧：${detail.before || '' } 新：${detail.after || '' }`"
                    :class="index > 0 ? 'pt-1' : ''"
                  >
                    ＜{{ detail.label }}＞&nbsp;旧：{{ detail.before }}&nbsp;新：{{ detail.after }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="changePage"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * 受注変更履歴
 */
export default {
  name: 'RevisionHistoriesDialog',
  components: {},
  mixins: [],
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      updateHistoryHeaders: [
        { value: 'updated_at', text: '更新日時', width: '16%' },
        { value: 'updated_by', text: '更新者', width: '9%' },
        { value: 'manifest_id', text: 'DXEマニ番号', width: '10%' },
        { value: 'category', text: '更新内容', width: '19%' },
        { value: 'detail', text: '詳細', width: '46%' },
      ],
      changeHistories: [],
      updatedHistories:[],
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      if (newValue)  {
        this.page = 1
        this.searchHistories()
      }
    },
  },
  mounted() {},
  created() {
  },
  methods: {
    ...mapActions('DriverOrderAcceptCollectionRevisionHistory', {
      fetchHistories: 'index',
    }),
    closeButtonClickEvent () {
      this.$emit('closeUpdateHistoryModal')
    },
    changePage () {
      this.searchHistories()
    },
    searchHistories () {
      let params = { page: this.page }
      this.fetchHistories({ order_id: this.order.id, params: params }).then((content) => {
        this.changeHistories = content.order_change_histories
        this.pagination = content.pagination
      })
    },
  }
}
</script>

<style scoped>

</style>
